import { useTranslation } from "react-i18next";
import TitleDescription from "../../../../components/newMotorPolicy/titleDescription/titleDescription";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import usePolicyCancellationFlow from "../../../../hooks/usePolicyCancellationFlow";
import BottomLayout from "../../../motorInsurancePages/policyOverview/managePolicy/policyCancellationFlow/bottomLayout";
import PolicyCancellationMotorLayout from "../../../motorInsurancePages/policyOverview/managePolicy/policyCancellationFlow/policyCancellationMotorLayout";
import {
  cancellationReasons,
} from "../../../motorInsurancePages/policyOverview/managePolicy/policyCancellationFlow/data";
import { useState } from "react";

const CyberSecurityCancellationReasonPage = ({ 
  handleNavigationToPolicyOverview, 
  setSelectedReasonOut 
}) => {
  const translate = useLanguageTranslate();
  const { handleNextSubstep } = usePolicyCancellationFlow();
  const { t } = useTranslation();

  const [selectedReason, setSelectedReason] = useState("");

  const handleReasonSelect = (reason) => {
    setSelectedReason(reason);
    setSelectedReasonOut(reason);
  };

  const continueClickHandler = () => {
    if (selectedReason) {
      handleNextSubstep();
    }
  };

  return (
    <PolicyCancellationMotorLayout
      is_hide_back_btn={true}
      show_close_btn={true}
      handleCloseBtnClick={handleNavigationToPolicyOverview}
      btn_onClick={continueClickHandler}
      btn_disabled={!selectedReason}
      btn_label={translate("Continue", "التالي")}
      CancellationAdditionalComponent={
        <BottomLayout
          className="btvk"
          btn_onClick={continueClickHandler}
          btn_disabled={!selectedReason}
          btn_label={translate("Continue", "التالي")}
          handleNavigationToPolicyOverview={handleNavigationToPolicyOverview}
        />
      }
    >
      <div className="flex flex-col items-center mx-auto max-w-lg max767:p-5 max767:mt-0 max767:pt-0 max767:pb-[50px]">
        <div className="flex justify-center items-center w-full">
          <div className=" p-0 w-full ">
            <TitleDescription
              title={translate(
                "Reason for Cancellation",
                "سبب الإلغاء"
              )}
              description={translate(
                "Please select the reason for cancelling your cyber security policy.",
                "يرجى اختيار سبب إلغاء وثيقة الأمن السيبراني."
              )}
            />

            {/* Cancellation Reasons */}
            <div className="mt-6 space-y-3">
              {cancellationReasons.map((reason, index) => (
                <div
                  key={index}
                  className={`p-4 rounded-lg border cursor-pointer transition-all ${
                    selectedReason === reason.label
                      ? "border-[#00719A] bg-[#E3F8FF]"
                      : "border-[#DDE2E4] bg-white hover:border-[#B0BEC5]"
                  }`}
                  onClick={() => handleReasonSelect(reason.label)}
                >
                  <div className="flex items-center">
                    <div
                      className={`w-5 h-5 rounded-full border-2 flex items-center justify-center mr-3 rtl:mr-0 rtl:ml-3 ${
                        selectedReason === reason.label
                          ? "border-[#00719A] bg-[#00719A]"
                          : "border-[#DDE2E4]"
                      }`}
                    >
                      {selectedReason === reason.label && (
                        <div className="w-2.5 h-2.5 rounded-full bg-white"></div>
                      )}
                    </div>
                    <span className="text-[#1A2024] font-medium">
                      {translate(reason.label, reason.label_ar)}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </PolicyCancellationMotorLayout>
  );
};

export default CyberSecurityCancellationReasonPage;